export default "__VITE_ASSET__3647101e__$_?component__"